import axios from "axios";

export const getOffers = async () =>
  await axios.get(`${process.env.REACT_APP_API}/offers`);

export const getMiniOffers = async (slug, delivery, store) =>
  await axios.get(`${process.env.REACT_APP_API}/offer/${slug}?type=mini&&delivery=${delivery}&&store=${store}`);

export const getOffer = async (slug, page, limit) =>
  await axios.get(`${process.env.REACT_APP_API}/offer/${slug}?page=${page}&limit=${limit}`);

export const removeOffer = async (slug, authtoken) =>
  await axios.delete(`${process.env.REACT_APP_API}/offer/${slug}`, {
    headers: {
      authtoken,
    },
  });

export const updateOffer = async (slug, offer, products, authtoken) =>
  await axios.put(`${process.env.REACT_APP_API}/offer/${slug}`, { tag: offer, products: products }, {
    headers: {
      authtoken,
    },
  });

export const createOffer = async (category, authtoken) =>
  await axios.post(`${process.env.REACT_APP_API}/offer`, category, {
    headers: {
      authtoken,
    },
  });

export const getFeaturedOffers = async () =>
  await axios.get(`${process.env.REACT_APP_API}/featured-offers`);

export const getConditionedOffers= async (offer, page) =>
  await axios.get(`${process.env.REACT_APP_API}/tagged-products?offer=${offer}&page=${page}`);
